const breakpoints = {
  keys: ['xs', 'sm', 'md', 'lg', 'xl'],
  values: {
    xs: 0,
    sm: 852,
    md: 1020,
    lg: 1220,
    xl: 1220,
  },
}

export default breakpoints
